export const normalizeString = (str = "") => {
  const formatted = str.replace(/[-_]+/g, " ").trim().toLowerCase();

  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};
